console.log('wallpaper-calculator.js loaded');



window.WallpaperCalculator = class {
  constructor() {
    console.log('WallpaperCalculator constructor called');

    // 1. Check if we are on a product page
    if (!this.isProductPage()) {
      console.log('Not a product page, skipping calculator initialization');
      return;
    }

    // 2. Initialize important variables
    this.pricePerSqft = 0;
    this.initialized = false;
    console.log('pricePerSqft set to 0, initialized set to false');

    // 3. Defer initialization until DOM is ready
    if (document.readyState === 'loading') {
      console.log('Document still loading, adding DOMContentLoaded listener');
      document.addEventListener('DOMContentLoaded', () => this.initialize());
    } else {
      console.log('Document readyState is complete, initializing after 500ms');
      setTimeout(() => this.initialize(), 500);
    }
  }

  /**
   * Checks if the current page has elements that indicate it’s a product page
   */
  isProductPage() {
    const hasProductForm = !!document.querySelector('.js-product-form');
    const hasWallpaperCustomization = !!document.querySelector('.wallpaper-customization-form');
    console.log('Checking if isProductPage ->', { hasProductForm, hasWallpaperCustomization });
    return hasProductForm || hasWallpaperCustomization;
  }

  /**
   * Main initialization after DOM is ready
   */
  initialize() {
    try {
      console.group('Calculator Initialization');

      // Prevent double-initialization
      if (this.initialized) {
        console.log('Calculator already initialized, skipping');
        console.groupEnd();
        return;
      }

      // 1. Find the .js-product-form
      console.log('Looking for product form with class: .js-product-form');
      this.form = document.querySelector('.js-product-form');
      if (!this.form) {
        console.error('Product form not found, cannot initialize calculator');
        console.groupEnd();
        return;
      }

      console.log('Found product form:', {
        id: this.form.id,
        className: this.form.className,
        action: this.form.action
      });

      // 2. Add Custom/Sample toggle buttons if they don't exist
      const wallpaperForm = document.querySelector('.wallpaper-customization-form');
      if (wallpaperForm && !document.querySelector('.size-toggle-container')) {
        console.log('Adding size toggle buttons...');
        
        // Create toggle buttons container
        const toggleContainer = document.createElement('div');
        toggleContainer.className = 'size-toggle-container';
        toggleContainer.innerHTML = `
          <button class="size-toggle-btn active" data-size="custom">Custom</button>
          <button class="size-toggle-btn" data-size="sample">Sample</button>
          <button class="whatsapp-link" onclick="handleWhatsAppOrder()">Order on WhatsApp</button>

        `;

        // Create sample size info element
        const sampleInfo = document.createElement('div');
        sampleInfo.className = 'sample-size-info';
        sampleInfo.style.display = 'none';
        sampleInfo.innerHTML = '<strong>A4 Sample with size: 8.3 inches by 11.7 inches</strong>';

        // Insert after the price display
        const priceDisplay = wallpaperForm.querySelector('.price-per-sqft');
        if (priceDisplay) {
          priceDisplay.after(toggleContainer);
          toggleContainer.after(sampleInfo);
        }

        // Update sample form button text
        const sampleFormBtn = document.querySelector('.sample-form button');
        if (sampleFormBtn) {
          sampleFormBtn.textContent = 'ADD TO CART';
          sampleFormBtn.className = 'btn btn--large add-to-cart';
        }
      }

      // 3. Validate presence of hidden fields
      console.group('Validating Form Fields');
      const requiredFields = [
        'input[name="id"]',                   // variant ID
        'input[name="quantity"]',            // quantity
        'input[name="properties[Width]"]',
        'input[name="properties[Height]"]',
        'input[name="properties[Total Size]"]',
        'input[name="properties[Price per sqft]"]',
        'input[name="properties[Total Price]"]'
      ];

      const fieldStatus = requiredFields.map((selector) => {
        const field = this.form.querySelector(selector);
        return {
          field: selector,
          exists: !!field,
          value: field ? field.value : 'not found'
        };
      });
      console.log('Required fields status:', fieldStatus);
      console.groupEnd();

      // 4. Initialize variant picker
      console.log('Initializing variant picker...');
      this.initializeVariantPicker();

      // 5. Set up event listeners for custom size inputs and toggle buttons
      console.log('Initializing event listeners...');
      this.initializeEventListeners();

      // 6. Hide sample form initially
      const sampleForm = document.getElementById('sample-form');
      if (sampleForm) {
        sampleForm.style.display = 'none';
      }

      // 7. Mark as initialized
      this.initialized = true;
      console.log('Calculator initialization complete');
    } catch (error) {
      console.error('Error in initialize:', error);
    } finally {
      console.groupEnd();
    }
  }
  /**
   * If your theme uses <variant-picker>, initialize it so we can track pricePerSqft
   */
  initializeVariantPicker() {
    const maxAttempts = 5;
    let attempts = 0;

    const tryInitialize = () => {
      try {
        console.log(`Variant picker init attempt #${attempts}`);
        const variantPicker = document.querySelector('variant-picker');

        if (variantPicker && typeof variantPicker.getSelectedVariant === 'function') {
          // Found the variant picker
          const selectedVariant = variantPicker.getSelectedVariant();
          if (selectedVariant) {
            this.pricePerSqft = selectedVariant.price / 100;
            console.log('Initial price per sqft from selected variant:', this.pricePerSqft);
            this.updateCalculations();
          }

          variantPicker.addEventListener('change', () => {
            const selectedVariant = variantPicker.getSelectedVariant();
            if (selectedVariant) {
              this.pricePerSqft = selectedVariant.price / 100;
              console.log('Updated price per sqft on variant change:', this.pricePerSqft);
              this.updateCalculations();
            }
          });
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(tryInitialize, 100 * attempts);
        }
      } catch (error) {
        console.error('Error in variant picker initialization:', error);
      }
    };

    tryInitialize();
  }

  /**
   * Set up listeners for custom size (width, height) changes
   */
  initializeEventListeners() {
      try {
        // Size toggle buttons initialization
        const toggleBtns = document.querySelectorAll('.size-toggle-btn');
        const customSizeInputs = document.querySelector('.size-inputs-container');
        const totalContainer = document.querySelector('.totals-container');
        const sampleSizeInfo = document.querySelector('.sample-size-info');
        const sampleForm = document.getElementById('sample-form');
        const sizeTitle = document.querySelector('.size-title');
        const minimumNote = document.querySelector('.minimum-order-note');
  
        if (toggleBtns.length) {
          toggleBtns.forEach(btn => {
            btn.addEventListener('click', () => {
              // Remove active class from all buttons
              toggleBtns.forEach(b => b.classList.remove('active'));
              // Add active class to clicked button
              btn.classList.add('active');
  
              if (btn.dataset.size === 'sample') {
                // Hide custom elements
                if (customSizeInputs) customSizeInputs.style.display = 'none';
                if (totalContainer) totalContainer.style.display = 'none';
                if (sizeTitle) sizeTitle.style.display = 'none';
                if (minimumNote) minimumNote.style.display = 'none';
                // Show sample info
                if (sampleSizeInfo) sampleSizeInfo.style.display = 'block';
                // Switch forms
                if (this.form) this.form.style.display = 'none';
                if (sampleForm) sampleForm.style.display = 'block';
              } else {
                // Show custom elements
                if (customSizeInputs) customSizeInputs.style.display = 'flex';
                if (totalContainer) totalContainer.style.display = 'flex';
                if (sizeTitle) sizeTitle.style.display = 'block';
                if (minimumNote) minimumNote.style.display = 'block';
                // Hide sample info
                if (sampleSizeInfo) sampleSizeInfo.style.display = 'none';
                // Switch forms
                if (this.form) this.form.style.display = 'block';
                if (sampleForm) sampleForm.style.display = 'none';
              }
            });
          });
        }

  
        // Original width/height input handling
        const widthInput = document.getElementById('width');
        const heightInput = document.getElementById('height');
        const widthErrorMsg = document.getElementById('width-error-msg');
        const heightErrorMsg = document.getElementById('height-error-msg');
        
        console.log('Attempting to attach listeners to #width and #height:', {
          widthFound: !!widthInput,
          heightFound: !!heightInput
        });
  
        if (widthInput && heightInput) {
          [widthInput, heightInput].forEach((input) => {
            input.addEventListener('blur', () => {
              const value = parseFloat(input.value || '0');
              const errorMsg = input.id === 'width' ? widthErrorMsg : heightErrorMsg;
              
              if (errorMsg) { // Add this check
                if (value < 24) {
                  errorMsg.textContent = `${input.id.charAt(0).toUpperCase() + input.id.slice(1)} must be at least 24 inches`;
                  errorMsg.style.display = 'block';
                  console.log(`Showing error for ${input.id}:`, errorMsg.textContent); // Debug log
                } else {
                  errorMsg.style.display = 'none';
                  console.log(`Hiding error for ${input.id}`); // Debug log
                }
              }
              
              this.validateNumericInput(input);
              this.updateCalculations();
            });
        
            input.addEventListener('input', () => {
              const value = parseFloat(input.value || '0');
              const errorMsg = input.id === 'width' ? widthErrorMsg : heightErrorMsg;
              
              if (errorMsg) { // Add this check
                if (value < 24) {
                  errorMsg.textContent = `${input.id.charAt(0).toUpperCase() + input.id.slice(1)} must be at least 24 inches`;
                  errorMsg.style.display = 'block';
                } else {
                  errorMsg.style.display = 'none';
                }
              }
              
              this.validateNumericInput(input);
              this.updateCalculations();
            });
          });
        }
  
        // Variant picker handling
        const variantPicker = document.querySelector('variant-picker');
        const sampleColorInput = document.getElementById('sample-color');
        const samplePaperInput = document.getElementById('sample-paper');
        console.log('inside initializeEventListeners');
  
        if (sampleForm && variantPicker && typeof variantPicker.getSelectedVariant === 'function') {
          sampleForm.addEventListener('submit', (event) => {
            const selectedVariant = variantPicker.getSelectedVariant();
            if (selectedVariant) {
              sampleColorInput.value = selectedVariant.option1 || '';
              samplePaperInput.value = selectedVariant.option2 || '';
              
              console.log('Setting sample color to:', sampleColorInput.value);
              console.log('Setting sample paper type to:', samplePaperInput.value);
            }
          });
        }
  
        // Add to Cart validation
        const addToCartBtn = document.querySelector('.btn.btn--large.add-to-cart');
        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', (evt) => {
            // Only validate dimensions if Custom size is selected
            const isCustomSelected = document.querySelector('.size-toggle-btn[data-size="custom"]').classList.contains('active');
            
            if (isCustomSelected) {
              const wVal = parseFloat(widthInput.value || '0');
              const hVal = parseFloat(heightInput.value || '0');
              if (wVal < 24 || hVal < 24) {
                evt.preventDefault();
                alert('Width and Height must each be at least 24 inches!');
              }

              // Ensure quantity is set before form submission
              const quantityInput = this.ensureQuantityInput(this.form);
              if (!quantityInput || !quantityInput.value) {
                  evt.preventDefault();
                  console.error('Quantity input not found or empty');
                  return;
              }
            }
          });
        }
    
        console.log('All event listeners initialized');
      } catch (error) {
        console.error('Error initializing event listeners:', error);
      }
  }


  /**
   * Ensures there is an <input name="quantity"> in the form
   */
  ensureQuantityInput(form) {
      if (!form) {
          console.error('No form provided to ensureQuantityInput');
          return null;
      }
      
      console.log('Ensuring <input name="quantity"> exists in form...');
      let input = form.querySelector('input[name="quantity"]');
      
      if (!input) {
          console.log('No quantity input found, creating one...');
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          form.appendChild(input);
      }
      return input;
  }
  
  /**
   * Called whenever width/height changes or variant changes
   */
  updateCalculations() {
    try {
      console.log('updateCalculations() called, proceeding with calculateCustomSize()');
      this.calculateCustomSize();
    } catch (error) {
      console.error('Error updating calculations:', error);
    }
  }

  /**
   * Always use custom size
   */
    calculateCustomSize() {
      console.group('calculateCustomSize()');
      try {
          const widthInput = document.getElementById('width');
          const heightInput = document.getElementById('height');
  
          // If they exist, parse them
          const widthVal = parseFloat(widthInput?.value) || 0;
          const heightVal = parseFloat(heightInput?.value) || 0;
  
          console.log('Parsed user input -> width:', widthVal, ' height:', heightVal);
  
          if (widthVal && heightVal) {
              // Convert to sqft and round to nearest integer
              let area = Math.ceil((widthVal * heightVal) / 144);
              // Enforce minimum order size
              area = Math.max(area, 50);
              console.log(`Calculated area = ${area} sqft (after min sqft check)`);
  
              const totalPrice = (area * this.pricePerSqft).toFixed(2);
              console.log(`Calculated totalPrice = ${totalPrice} (pricePerSqft = ${this.pricePerSqft})`);
  
              // Update visible elements
              const totalSizeElement = document.getElementById('total-size');
              const totalPriceElement = document.getElementById('total-price');
  
              if (totalSizeElement) {
                  totalSizeElement.textContent = `${area}`;
                  console.log(`Displayed #total-size as: ${area}`);
              }
              if (totalPriceElement) {
                  totalPriceElement.textContent = `${totalPrice}`;
                  console.log(`Displayed #total-price as: ${totalPrice}`);
              }
  
              // Update hidden form fields
              if (this.form) {
                  // Update quantity input
                  const quantityInput = this.ensureQuantityInput(this.form);
                  if (quantityInput) {
                      quantityInput.value = area.toString();
                      console.log('Updated quantity input to:', area);
                  }
  
                  // Update other hidden fields
                  this.updateFormFields({
                      width: widthVal.toString(),
                      height: heightVal.toString(),
                      totalSize: `${area} sqft`,
                      quantity: area,
                      price: totalPrice
                  });
              } else {
                  console.error('Form not found, could not update quantity');
              }
          }
      } catch (error) {
          console.error('Error calculating custom size:', error);
      } finally {
          console.groupEnd();
      }
  }

  /**
   * If you still want to store these in hidden inputs:
   * properties[Width], properties[Height], etc.
   */
  updateFormFields(data) {
    console.log('updateFormFields() -> updating hidden properties', data);
    try {
      const fields = {
        // If you removed sizeType entirely, you can skip it:
        // 'size-type-property': data.sizeType,
        'width-property': data.width || '',
        'height-property': data.height || '',
        'total-size-property': data.totalSize,
        'price-per-sqft-property': this.pricePerSqft.toFixed(2),
        'total-price-property': data.price
      };

      Object.entries(fields).forEach(([id, value]) => {
        const element = document.getElementById(id);
        if (element) {
          element.value = value;
          console.log(`Updated #${id} to "${value}"`);
        } else {
          console.log(`Could not find #${id} in DOM, skipping`);
        }
      });
    } catch (error) {
      console.error('Error updating form fields:', error);
    }
  }

  /**
   * Prevent non-numeric input
   */
  validateNumericInput(input) {
    try {
      const oldValue = input.value;
      const newValue = oldValue.replace(/[^0-9]/g, '');

      if (oldValue !== newValue) {
        console.log(`Stripped invalid chars from ${oldValue} -> ${newValue}`);
        input.value = newValue;
      }

      const numValue = parseInt(newValue, 10);
      if (isNaN(numValue) || numValue < 0) {
        console.log(`Input was invalid or negative, forcing to "0"`);
        input.value = '0';
      }
    } catch (error) {
      console.error('Error validating numeric input:', error);
      input.value = '0';
    }
  }

};

// Add WhatsApp order handler
window.handleWhatsAppOrder = () => {
  try {
    const productUrl = window.location.href;
    // Get product title from the hidden input in sample form
    const productTitleInput = document.getElementById('sample-product-name');
    console.log("product title is: ",productTitleInput)
    const productTitle = productTitleInput ? productTitleInput.value : 'this product';
    
    // Create and encode message
    const message = `Hello, I am interested in ${productTitle}. ${productUrl}`;
    console.log("message is: ",message)

    const encodedMessage = encodeURIComponent(message);
    console.log("encodedMessage is: ",encodedMessage)

    // Open WhatsApp
    const whatsappLink = `https://wa.me/919289190162?text=${encodedMessage}`;
    window.open(whatsappLink, '_blank');
  } catch (error) {
    console.error('Error handling WhatsApp order:', error);
  }
};

// Initialize the calculator (singleton)
if (!window.calculatorInstance) {
  console.log('Creating a new WallpaperCalculator instance');
  window.calculatorInstance = new window.WallpaperCalculator();
} else {
  console.log('calculatorInstance already exists, skipping creation');
}
